import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';
import { SitesComponent } from './components/sites/sites.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CdkTreeModule } from '@angular/cdk/tree';
import { RouterModule } from '@angular/router';
// Primeng modules
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { BlockableDivModule } from '../shared/components/blockable-div/blockable-div.module';
import { SiteDialogComponent } from './components/site-dialog/site.dialog.component';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FileUploadModule } from 'primeng/fileupload';
import { GoogleMapsModule } from '@angular/google-maps';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MenuModule } from 'primeng/menu';
import { DeviceTreeComponent } from './components/device-tree/device-tree.component';
import { DevicesListComponent } from './components/devices-list/devices-list.component';
import { TagModule } from 'primeng/tag';
import { BadgeModule } from 'primeng/badge';
import { SiteButtonBarComponent } from './site-button-bar/site-button-bar.component';
import { TreeModule } from 'primeng/tree';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { DeviceTreeTableComponent } from './components/device-treetable/device-treetable.component';
import { TreeTableModule } from 'primeng/treetable';
import { AccordionModule } from 'primeng/accordion';
import { SiteCardsFiltersComponent } from '../shared/components/site-card/site-cards-filters.component';

@NgModule({
    declarations: [
        DeviceTreeComponent,
        DeviceTreeTableComponent,
        SiteButtonBarComponent,
        DevicesListComponent,
        SiteDialogComponent,
        SiteCardsFiltersComponent,
        SitesComponent,
    ],
    imports: [
        AccordionModule,
        AutoCompleteModule,
        AvatarGroupModule,
        AvatarModule,
        BadgeModule,
        BlockUIModule,
        BlockableDivModule,
        ButtonModule,
        CdkTreeModule,
        CommonModule,
        ConfirmDialogModule,
        DropdownModule,
        FileUploadModule,
        GoogleMapsModule,
        InputTextModule,
        MenuModule,
        ReactiveFormsModule,
        RippleModule,
        RouterModule,
        SharedModule,
        TagModule,
        TreeModule,
        TreeTableModule,
    ],
    exports: [
        SitesComponent,
        SiteDialogComponent,
        SiteCardsFiltersComponent,
        DevicesListComponent,
        DeviceTreeTableComponent
    ]
})
export class SitesModule { }
